import { DateTime } from 'luxon';
import { SubjectAnpr } from 'shell/models/act-category-list';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';

export const transformFamilyCoexistence = (
  intestatario: SubjectAnpr
): AccordionFamilyCoexistence => {
  return {
    membershipDate: intestatario.dataNascita ? DateTime.fromISO(intestatario.dataNascita) : null,
    bondDate: intestatario.dataNascita ? DateTime.fromISO(intestatario.dataNascita) : null,
  };
};
